export const hasValueInObj = obj =>
  Object.values(obj).some(
    value => value !== null && value !== undefined && value !== '',
  );
